import { render, staticRenderFns } from "./userCzlist.vue?vue&type=template&id=0aafd5de&scoped=true"
import script from "./userCzlist.vue?vue&type=script&lang=js"
export * from "./userCzlist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aafd5de",
  null
  
)

export default component.exports